import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1 className="sm:text-4xl text-2xl font-bold my-6 text-gray-900">
        404: Page not found!
      </h1>
    </div>
  );
};

export default NotFound;
